import { FC } from 'react';
import { Details, Row, Header, Body, BodyItems } from '@/components/SearchForm/AdditionalSearchField';
import { MultiTagFilteringFieldRow } from '@/components/SearchForm/MultiTagFilteringFieldRow';
import { JobName } from 'jbc-front/components/Text/JobName';
import { GroupsSelectBoxControl } from '@/components/GroupsSelectBox';
import { OfficesSelectBoxControl } from '@/components/OfficesSelectBox';
import { withNull } from '@/components/utils/form_helpers';
import { useQuery } from '@/hooks/graphql/useQuery';
import { ADDITIONAL_SEARCH_QUERY, AdditionalSearchQuery } from './query';

export const AdditionalSearchField: FC = () => {
  const { data, loading } = useQuery<AdditionalSearchQuery>(ADDITIONAL_SEARCH_QUERY, { fetchPolicy: 'network-only' });
  if (loading || !data?.client) {
    return null;
  }
  return (
    <Details>
      <Row>
        <Header>適用事業所</Header>
        <Body>
          <BodyItems>
            <OfficesSelectBoxControl
              name="offices"
              options={data.client.offices.map(office => ({
                value: String(office.id),
                label: office.name
              }))}
            />
          </BodyItems>
        </Body>
      </Row>
      <Row>
        <Header>グループ</Header>
        <Body>
          <BodyItems>
            <GroupsSelectBoxControl
              name="groups"
              options={data.client.groups.map(group => ({
                value: group,
                label: group
              }))}
            />
          </BodyItems>
        </Body>
      </Row>
      <MultiTagFilteringFieldRow
        header="役職"
        name="positions"
        list={withNull(data.client.positions.map(type => ({ name: type, id: type })))}
        NameWrapper={JobName}
      />
      <MultiTagFilteringFieldRow
        header="雇用形態"
        name="employmentTypes"
        list={withNull(data.client.employmentTypes.map(type => ({ name: type, id: type })))}
        NameWrapper={JobName}
      />
    </Details>
  );
};
